export async function readableStreamToJson(readableStream) {
  const reader = readableStream.getReader();
  let text = "";

  while (true) {
    const { done, value } = await reader.read();

    if (done) {
      break;
    }

    text += new TextDecoder().decode(value);
  }

  // Parse the accumulated text as JSON
  return JSON.parse(text);
}

export async function readableStreamToPng(readableStream) {
  const reader = readableStream.getReader();
  const chunks = [];

  while (true) {
    const { done, value } = await reader.read();

    if (done) {
      break;
    }

    chunks.push(value);
  }

  const blob = new Blob(chunks, { type: "image/png" });

  // Create an <img> element to display the PNG (optional)
  const img = document.createElement("img");
  img.src = URL.createObjectURL(blob);

  return blob;
}
